import { Omit } from '@material-ui/core';
import Button, { ButtonProps } from '@material-ui/core/Button';
import React from 'react';

type Props = {
  submitComponent: React.ReactNode;
  submitting: boolean;
  disabled?: boolean;
};

export const FormSubmitButton = React.forwardRef<
  HTMLButtonElement,
  Props & Omit<ButtonProps, 'onClick'>
>((props, ref) => {
  const { disabled, submitting, submitComponent, children, ...other } = props;

  return (
    <Button
      ref={ref}
      variant="contained"
      color="primary"
      {...other}
      disabled={disabled || submitting}
      type="submit"
    >
      {submitting ? submitComponent : children}
    </Button>
  );
});
